import { observer } from "mobx-react-lite";
import { enhancedContentSourceLocation } from "../../../lib/ContentSource";
import { ReportSection, ReportSectionHeader, Literal, IndentedBlock, ReportSubSectionHeader, InferredTypeNameBlock, InferredTypeName, SearchDetails, SearchResultEncodingFoundSpan } from "../common-styles";
import { RecordingViewState } from "../RecordingViewState";
import { SearchResultDetailsView } from "./SearchResultDetailsView";



export const SearchReportBySearchTermView = observer(
	({ recordingViewState }: { recordingViewState: RecordingViewState; }
	) => {
		return (<>
			{recordingViewState.searchState.searchResultsBySearchTerm.map(({ searchTerm, destinations }) => (
				<ReportSection key={searchTerm}>
					<ReportSectionHeader><Literal>{searchTerm}</Literal></ReportSectionHeader>
					<IndentedBlock>{destinations.map(({ destinationRegisteredDomain, sourcePages }) => sourcePages.map(({ sourceRegisteredDomain, encodings }) => (
						<IndentedBlock key={`${searchTerm}\0${destinationRegisteredDomain}\0${sourceRegisteredDomain}`}>
							<ReportSubSectionHeader>
								<Literal>{destinationRegisteredDomain}&nbsp;⟵&nbsp;{sourceRegisteredDomain}</Literal>
							</ReportSubSectionHeader>
							{encodings.map(({ encodingString, eventsAndResults, inferredTypeNames }, index) => (
								<IndentedBlock key={encodingString}> {inferredTypeNames.length === 0 ? null : (
									<InferredTypeNameBlock>
										{inferredTypeNames.map( (inferredTypeName, index) => (
											<span key={inferredTypeName}>
												{index === 0 ? null : (<span>,&#32;</span>)}
												<InferredTypeName>{inferredTypeName}</InferredTypeName>
											</span>
										))}
									</InferredTypeNameBlock>
								)}
									<SearchDetails key={encodingString}>
										<summary>
											<SearchResultEncodingFoundSpan>{encodingString}</SearchResultEncodingFoundSpan>&#32;found at:
										</summary>
										{eventsAndResults.map(({ event, searchResult }) => (
											<SearchResultDetailsView
												key={`${event.eventIndex}\0${searchResult.encodedSearchTerm}\0${searchResult.position}\0${enhancedContentSourceLocation(searchResult)}`}
												displayJson={recordingViewState.setObjectToDisplayAsJson}
												{...{ event, searchResult }} />
										))}
									</SearchDetails>
								</IndentedBlock>
							))}
						</IndentedBlock>
					))
					).flat()}</IndentedBlock>
				</ReportSection>
			))}</>);
	});
